import React from 'react';
import '../../styles/layout.css';

export default function OutlierList({ items }) {
  if (!items || items.length === 0) {
    return (
      <div style={{ padding: '14px 16px', fontSize: 11, color: 'var(--tx3)' }}>
        Fleet utilisation is balanced — no significant outliers detected.
      </div>
    );
  }

  return (
    <>
      {items.map(r => {
        const col = r.avgHrs >= 8 ? '#16a34a' : r.avgHrs >= 5 ? '#d97706' : '#dc2626';
        return (
          <div className="outlier" key={r.R}>
            <div className="outl-icon">✈️</div>
            <div className="outl-body">
              <div>
                <span className="outl-reg">{r.R}</span>
                <span className={`outl-d ${r.delta < 0 ? 'outl-dn' : 'outl-up'}`}>
                  {r.delta > 0 ? '+' : ''}{r.delta.toFixed(1)}h
                </span>
              </div>
              <div className="outl-type">{r.V} · {r.O}</div>
            </div>
            <div>
              <div className="outl-val" style={{ color: col }}>{r.avgHrs.toFixed(1)}h</div>
              <div className="outl-lbl">avg daily</div>
            </div>
          </div>
        );
      })}
    </>
  );
}
